import React from 'react';
import './cp-spinner.css';

const HooperLoading = () => {
  return (
    <>
      <div className="hooper_loading_overlay" /> {/* Full-screen overlay */}
      <div className="hooper_loading_dv_old">
        <div className="hooper_loading_spinner_icon" />
      </div>
    </>
  );
};

export default HooperLoading;
